/**
 * Cloud Retail attribution — session cookie + direct UserEvent POSTs.
 * window.CloudRetailPage is set in theme.liquid before this file loads.
 */
(function () {
  'use strict';

  var COOKIE = 'cloud_retail_session';
  var VISITOR_COOKIE = 'cloud_retail_visitor_id';

  // First-party visitor id. Minted here (not reliant on GTM) so it is always
  // present before add-to-cart writes cart attributes for the checkout pixel.
  function getVisitorId() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + VISITOR_COOKIE + '=([^;]*)'));
    if (m) return decodeURIComponent(m[1]);
    var id = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    // 2-year lifetime, site-wide, so search / ATC / purchase all share one id.
    document.cookie = VISITOR_COOKIE + '=' + encodeURIComponent(id) + '; path=/; max-age=63072000; SameSite=Lax';
    return id;
  }

  // Read / write the session cookie (tokens map + region).
  function load() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return { tokens: {}, region: '' };
    try {
      return JSON.parse(decodeURIComponent(m[1]));
    } catch (e) {
      return { tokens: {}, region: '' };
    }
  }

  function save(data) {
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(data)) + '; path=/; SameSite=Lax';
  }

  function getToken(productId) {
    return productId ? (load().tokens[String(productId)] || null) : null;
  }

  function getRegion() {
    return load().region || '';
  }

  function setRegion(region) {
    if (!region) return;
    var s = load();
    s.region = region;
    save(s);
  }

  // Map product IDs → attribution token from an AI search response.
  function mergeTokens(products, token) {
    if (!token || !products || !products.length) return;
    var s = load();
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (p && p.id != null && !s.tokens[String(p.id)]) {
        s.tokens[String(p.id)] = token;
      }
    }
    save(s);
  }

  function resetTokens() {
    document.cookie = COOKIE + '=; path=/; Max-Age=0';
  }

  // Append cr_at / cr_pid / cr_region so a new-tab PDP can re-seed the cookie.
  function appendAttributionParams(url, productId) {
    var token = getToken(productId);
    if (!url || !productId || !token) return url;
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('cr_at', token);
      u.searchParams.set('cr_pid', String(productId));
      var region = getRegion();
      if (region) u.searchParams.set('cr_region', region);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  // Seed cookie from URL params, then strip them from the address bar.
  function seedFromUrl() {
    var p = new URLSearchParams(location.search);
    var token = p.get('cr_at');
    var productId = p.get('cr_pid');
    if (!token || !productId) return;

    var s = load();
    s.tokens[String(productId)] = token;
    if (p.get('cr_region')) s.region = p.get('cr_region');
    save(s);

    p.delete('cr_at');
    p.delete('cr_pid');
    p.delete('cr_region');
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  function openProductLink(url, productId) {
    window.open(appendAttributionParams(url, productId), '_blank', 'noopener,noreferrer');
  }

  /**
   * POST a full Retail UserEvent to /retail/user-events (no GTM / dataLayer).
   * Callers omit optional fields; this does not strip or rewrite the payload.
   */
  function sendUserEvent(payload) {
    var page = window.CloudRetailPage || {};
    var endpoint = page.eventEndpoint || 'https://54.90.232.5.nip.io/retail/user-events';
    var eventKey = page.eventKey || 'behope-cloud-retail-events';
    var body = payload || {};

    if (!body.eventType) return Promise.resolve();
    if (!body.visitorId) body.visitorId = getVisitorId();
    if (!body.eventTime) body.eventTime = new Date().toISOString();
    if (!body.uri) body.uri = location.href;

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
        'X-Retail-Event-Key': eventKey,
      },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(function (err) {
      console.error('Failed to send Cloud Retail user event', err);
    });
  }

  // Public API for theme / AI search / buy-now helpers.
  window.CloudRetailAttribution = {
    mergeTokens: mergeTokens,
    resetTokens: resetTokens,
    getToken: getToken,
    getRegion: getRegion,
    setRegion: setRegion,
    getVisitorId: getVisitorId,
    appendAttributionParams: appendAttributionParams,
    openProductLink: openProductLink,
    sendUserEvent: sendUserEvent,
  };


  seedFromUrl();

  // Ensure the visitor id cookie exists on every page load.
  var visitorId = getVisitorId();

  // Page-view events (home / PDP) — posted as full UserEvents, not dataLayer.
  var page = window.CloudRetailPage;
  var region = getRegion() || (page && page.region) || '';
  var entity = region && region.toLowerCase();
  if (page && page.pageType === 'index') {
    sendUserEvent({
      eventType: 'home-page-view',
      eventTime: new Date().toISOString(),
      visitorId: visitorId,
      uri: location.href,
      ...(region && {
        entity: entity,
        attributes: { market: { text: [region] } },
      }),
      ...(document.referrer && { referrerUri: document.referrer }),
    });
  } else if (page && page.pageType === 'product' && page.productId) {
    var attributionToken = getToken(page.productId);
    sendUserEvent({
      eventType: 'detail-page-view',
      eventTime: new Date().toISOString(),
      visitorId: visitorId,
      productDetails: [{ product: { id: String(page.productId) } }],
      uri: location.href,
      ...(region && {
        entity: entity,
        attributes: { market: { text: [region] } },
      }),
      ...(document.referrer && { referrerUri: document.referrer }),
      ...(attributionToken && { attributionToken: attributionToken }),
    });
  }
})();
